export const systemPresetColor = [
  '#A1ECFF',
  '#A1F5E8',
  '#A1E6B5',
  '#DDFF8F',
  '#FFEF8A',
  '#FFE0A6',
  '#FFCAA8',
  '#FFADB6',
  '#FF96AD',
  '#D4A8FF',
  '#99CCFF',
  '#B3D5FF',
  '#16B0F1',
  '#16B8B1',
  '#1BA854',
  '#77C404',
  '#FDC200',
  '#FF991C',
  '#FF5F1F',
  '#FB2323',
  '#F90D58',
  '#701DF0',
  '#0E5FD8',
  '#276FF5',
  '#FFFFFF',
  '#FAFAFA',
  '#F5F5F5',
  '#F2F2F2',
  '#E5E5E5',
  '#D9D9D9',
  '#CCCCCC',
  '#999999',
  '#666666',
  '#404040',
  '#212121',
  '#000000',
]
